module.exports = __webpack_public_path__ + "static/media/logo.1238c3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/logo.png
// module id = 1325
// module chunks = 114